$(function () {

    // Fix for Bootstrap 4 Dropdown Clipping in DataTables
    $(document).on('show.bs.dropdown', '.dataTables_wrapper, .table-responsive', function (e) {
        var $container = $(e.target);
        var $dropdown = $container.find('.dropdown-menu');
        var $toggle = $container.find('.dropdown-toggle');

        // 1. Store original parent so we can put it back safely later
        $dropdown.data('dropdown-parent', $dropdown.parent());

        // 2. Detach and append directly to body
        $('body').append($dropdown.detach());

        // 3. Compute absolute viewport coordinates relative to button
        var offset = $toggle.offset();
        $dropdown.css({
            'display': 'block',
            'position': 'absolute',
            'top': offset.top + $toggle.outerHeight(),
            'left': offset.left,
            'z-index': 1055
        });
    });

    $(document).on('hide.bs.dropdown', '.dataTables_wrapper, .table-responsive', function (e) {
        var $container = $(e.target);

        // Find any body-appended dropdowns that belonged to this container
        $('body > .dropdown-menu').each(function () {
            var $dropdown = $(this);
            var $parent = $dropdown.data('dropdown-parent');

            if ($parent && $parent.length) {
                $dropdown.css({'display': '', 'top': '', 'left': '', 'position': '', 'z-index': ''});
                $parent.append($dropdown.detach());
            }
        });
    });

    /**
     * Drop Image
     * For Single Profile / Site Logo And Others
     */
    if ($('.drop_image').length) {
        $('.drop_image').inputFileZone({
            upload_url: url + '/upload/images',
            file_types_allowed: ['image/jpeg', 'image/png', 'image/vnd.adobe.photoshop'],
            max_file_size: 5 * 1024 * 1024, // 5MB
            height: '100px',
            width: '100px'
        })
    }

    /**
     * Payroll Payment Proof Uploader
     * ------------------------------------------------------------
     * Handled by the reusable .fileDropzone plugin (see resources/js/plugins/
     * file-dropzone.js, loaded in app.js). The "Mark as Paid" modal markup
     * declares a .intake-dropzone[data-file-dropzone] dropzone, so no per-page
     * JS is needed here — the plugin binds via delegation and also works for
     * modals injected dynamically by ajaxModal.
     */




    $('.btn-open-options').on('click', function () {
        $('.ui-theme-settings').toggleClass('settings-open');
    });

    $('.close-sidebar-btn').on('click', function () {

        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-container';
        $(containerElement).toggleClass(classToSwitch);

        var closeBtn = $(this);

        if (closeBtn.hasClass('is-active')) {
            closeBtn.removeClass('is-active');

        } else {
            closeBtn.addClass('is-active');
        }
    });


    $('.switch-container-class').on('click', function () {

        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-container';
        $(containerElement).toggleClass(classToSwitch);

        $(this).parent().find('.switch-container-class').removeClass('active');
        $(this).addClass('active');
    });

    $('.switch-theme-class').on('click', function () {

        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-container';

        if (classToSwitch == 'body-tabs-line') {
            $(containerElement).removeClass('body-tabs-shadow');
            $(containerElement).addClass(classToSwitch);
        }

        if (classToSwitch == 'body-tabs-shadow') {
            $(containerElement).removeClass('body-tabs-line');
            $(containerElement).addClass(classToSwitch);
        }

        $(this).parent().find('.switch-theme-class').removeClass('active');
        $(this).addClass('active');

    });

    $('.switch-header-cs-class').on('click', function () {
        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-header';

        $('.switch-header-cs-class').removeClass('active');
        $(this).addClass('active');

        $(containerElement).attr('class', 'app-header');
        $(containerElement).addClass('header-shadow ' + classToSwitch);
    });

    $('.switch-sidebar-cs-class').on('click', function () {
        var classToSwitch = $(this).attr('data-class');
        var containerElement = '.app-sidebar';

        $('.switch-sidebar-cs-class').removeClass('active');
        $(this).addClass('active');

        $(containerElement).attr('class', 'app-sidebar');
        $(containerElement).addClass('sidebar-shadow ' + classToSwitch);
    });




    $(".open-right-drawer").on('click', function () {
        $(this).addClass("is-active"),
            $(".app-drawer-wrapper").addClass("drawer-open"),
            $(".app-drawer-overlay").removeClass("d-none")
    })
    $(".drawer-nav-btn").on('click', function () {
        $(".app-drawer-wrapper").removeClass("drawer-open"),
            $(".app-drawer-overlay").addClass("d-none"),
            $(".open-right-drawer").removeClass("is-active")
    })
    $(".app-drawer-overlay").on('click', function () {
        $(this).addClass("d-none"),
            $(".app-drawer-wrapper").removeClass("drawer-open"),
            $(".open-right-drawer").removeClass("is-active")
    }),
        $(".mobile-toggle-nav").on('click', function () {
            $(this).toggleClass("is-active"),
                $(".app-container").toggleClass("sidebar-mobile-open")
        }),
        $(".mobile-toggle-header-nav").on('click', function () {
            $(this).toggleClass("active"),
                $(".app-header__content").toggleClass("header-mobile-open")
        }),
        $(".mobile-app-menu-btn").on('click', function () {
            $(".hamburger", this).toggleClass("is-active"),
                $(".app-inner-layout").toggleClass("open-mobile-menu")
        });

    $("input[type=checkbox][data-toggle^=toggle]").bootstrapToggle()


    $('.mobile-toggle-header-nav').on('click', function () {
        $(this).toggleClass('active');
        $('.app-header__content').toggleClass('header-mobile-open');
    });

    $('.mobile-toggle-nav').on('click', function () {
        $(this).toggleClass('is-active');
        $('.app-container').toggleClass('sidebar-mobile-open');
    });

    $('input[data-toggle="datepicker"], .datepicker').datepicker({
        todayHighlight: true,
        autoclose: true,
        format: 'yyyy-mm-dd',
        weekStart: 1
    }).attr('autocomplete', 'off');

    $('input[data-toggle="monthpicker"], .monthpicker').datepicker({
        format: "yyyy-mm",
        startView: "months",
        minViewMode: "months",
        autoclose: true
    }).attr('autocomplete', 'off');

    /**
     *  data-toggle="remove" || .remove_dom
     *  can be used to delete a div on child element click
     *  params: data-target, data-confirm
     * */

    $(document).on('click', '[data-toggle="remove"], .remove_dom', function () {
        var __this = $(this)
        if (__this.data('confirm')) {
            beautify.sweetConfirm(__this.data('confirm'), 'Click ok if you want to proceed', function (confirm) {
                if (confirm) {
                    beautify.remove_dom(__this.closest(__this.attr('data-target')), __this.attr('data-parent'));
                }
            });
        } else {
            beautify.remove_dom(__this.closest(__this.attr('data-target')), __this.attr('data-parent'));
        }
    });



    /**
     * Data Toggle [clone]
     * Clone A Div
     */
    $(document).on('click', '[data-toggle="clone"]', function (e) {
        var _clone_html = '';
        var _clone_target = $(this).data('target');
        var _clone_target_class = _clone_target.replace('.', '');

        $(this).closest(_clone_target).find('.form-control.select2').select2('destroy');
        $(this).closest(_clone_target).find('[data-toggle=toggle]').bootstrapToggle('destroy')
        _clone_html = $(this).closest(_clone_target).clone();
        $(this).closest(_clone_target).find('[data-toggle=toggle]').bootstrapToggle()
        $(this).closest(_clone_target).find('.form-control.select2').select2({
            theme: "bootstrap4",
            width: '100%'
        });

        $(_clone_html).find('input').val('');
        $(_clone_html).removeClass(_clone_target_class).addClass('toggle_removable_div');
        $(_clone_html).find('label').remove();
        $(_clone_html).find('[data-toggle="clone"]').attr('data-toggle', 'remove');
        $(_clone_html).find('.fa-plus').removeClass('fa-plus').addClass('fa-minus');


        if (jQuery().select2) {
            $(_clone_html).find('.select2').select2({
                theme: "bootstrap4",
                width: '100%'
            });
        }

        $(_clone_html).find('[data-toggle=toggle]').bootstrapToggle()

        if (jQuery().datepicker) {
            $(_clone_html).find(".datepicker").datepicker({
                todayHighlight: true,
                autoclose: true,
                format: 'yyyy-mm-dd'
            })
        }

        $(_clone_html).insertAfter(_clone_target);


        mdtimepicker('.timepicker', {
            timeFormat: 'hh:mm:ss.000',
            format: 'h:mm tt',
            theme: 'teal',
            hourPadding: true
        });

    });


    $(document).on('click', '[data-toggle="remove"]', function (e) {
        $(this).closest('.toggle_removable_div').fadeOut('fast', function () {
            $(this).closest('.toggle_removable_div').remove();
        });
    });



    /**
     * Date-range Picker
     */
    var start = moment().subtract(29, 'days');
    var end = moment();

    function cb(start, end) {
        $('#daterange span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
        $('#daterange').attr('start', start.format('YYYY-MM-DD'));
        $('#daterange').attr('end', end.format('YYYY-MM-DD'));
        $('#daterange').trigger('change');
    }

    $('#daterange').daterangepicker({
        startDate: start,
        endDate: end,
        ranges: {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
    }, cb);

    cb(start, end);

    /**
     * Select2
     */

    $('.select2').select2({
        theme: "bootstrap4",
        width: '100%'
    });

    $('.select2-tag').select2({
        theme: "bootstrap4",
        width: '100%',
        tags: true,
    });

    $(document).on('select2:open', (e) => {
        var target = e.target;
        setTimeout(() => {
            var $container = $(target).next('.select2-container');
            $container.find('.select2-search__field').focus();
        }, 0);
    });
    /**mm menu active */
    route_class = route.replace('.', '-')
    if ($('.mm-' + route_class).length) {
        $('.mm-active').removeClass('mm-active')
        $('.mm-' + route_class).addClass('mm-active');
        $('.mm-' + route_class).closest('.mm-auto_active').addClass('mm-active');
    }

    /**
     * This will adjust datatable on initialize
     */
    $('body').on('show.bs.tab', function () {
        setTimeout(function () {
            $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
        }, 200);
    });
    setTimeout(function () {
        // console.log('Fixing...')
        $.fn.dataTable.tables({ visible: true, api: true }).columns.adjust();
    }, 200);

    setTimeout(function () {
        // console.log('fixing datatable dropdown')
        var data_table_fix = $('.dataTable').DataTable();
        data_table_fix.on('draw', function () {
            var _btn_group = $(this).find('.dropdown-menu').eq(0);
            var _btn_height = _btn_group.height();

            if (($(this).height() < _btn_height + 100) && ($(window).width() >= 992)) {
                $(this).closest('.dataTables_scrollBody').removeClass('datatable_fix').addClass('datatable_fix');
            }
        });
    }, 100);

    // Initialize intl-tel-input & country auto-detect (single ipapi.co call)
    const phoneInput = $("#phone")[0];
    if (phoneInput) {
        fetch("https://ipapi.co/json")
            .then((res) => res.json())
            .then((data) => {
                var countryCode = (data && data.country_code) ? data.country_code.toLowerCase() : "us";

                // Phone input
                const geoIpLookup = function(successCallback) {
                    successCallback(countryCode);
                };

                const iti = intlTelInput(phoneInput, {
                    initialCountry: "auto",
                    preferredCountries: ["us", "ca", "bd"], // Pin USA, Canada, and Bangladesh to the top
                    geoIpLookup: geoIpLookup,
                    formatOnDisplay: true,
                    hiddenInput: "full_number",
                    nationalMode: false,
                    autoHideDialCode: false,
                    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js"
                });

                $(phoneInput).on("input", function() {
                    const countryData = iti.getSelectedCountryData();
                    if (!this.value.startsWith("+") && countryData && countryData.dialCode) {
                        this.value = "+" + countryData.dialCode;
                    }
                });

                // Country select auto-detect
                var countrySelect = document.getElementById('country');
                if (countrySelect && countrySelect.classList.contains('detect') && !countrySelect.value) {
                    var opt = countrySelect.querySelector('option[value="' + countryCode.toUpperCase() + '"]');
                    if (opt) {
                        countrySelect.value = countryCode.toUpperCase();
                        $(countrySelect).trigger('change');
                    }
                }
            })
            .catch(() => {
                // Fallback: init phone with US
                const iti = intlTelInput(phoneInput, {
                    initialCountry: "us",
                    formatOnDisplay: true,
                    preferredCountries: ["us", "ca", "bd"], // Pin USA, Canada, and Bangladesh to the top
                    hiddenInput: "full_number",
                    nationalMode: false,
                    autoHideDialCode: false,
                    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.js"
                });
                $(phoneInput).on("input", function() {
                    const countryData = iti.getSelectedCountryData();
                    if (!this.value.startsWith("+") && countryData && countryData.dialCode) {
                        this.value = "+" + countryData.dialCode;
                    }
                });
            });
    }


    $('[data-toggle="tooltip"]').tooltip();

    $('[data-toggle="tooltip-light"]').tooltip({
        template: '<div class="tooltip tooltip-light"><div class="tooltip-inner"></div></div>'
    });

    /**
     * Filter persistence — saves inputs inside .persist_selection to localStorage
     * and restores them on page load. Add class="persist_selection" to any container.
     */
    if ($('.persist_selection').length) {
        $('.persist_selection').each(function() {
            var $container = $(this);
            beautify.restoreFilters($container);

            $container.on('change', 'input, select, textarea', function() {
                beautify.saveFilters($container);
            });
        });
    }


    // scheduler un assign students
    $(document).on('click', '.unassign-student', function(e) {
        e.preventDefault();
        var $btn = $(this);
        var studentId = $btn.data('student-id');
        var studentName = $btn.data('student-name');
        var scheduleId = $btn.data('schedule-id');
        var reloadPage = $btn.data('reload-page');

        beautify.sweetConfirm(
            'Remove ' + studentName + '?',
            'This student will be removed from this schedule slot.',
            function(confirmed) {
                if (!confirmed) return;

                $.ajax({
                    url: url + '/schedules/' + scheduleId + '/unassign-student',
                    type: 'POST',
                    data: {
                        _token: csrf_token,
                        student_id: studentId
                    },
                    success: function(data) {
                            if (data.status === 'success') {
                            if (reloadPage) {
                                beautify.notifyAndReload('success', data.message);
                                return;
                            }

                            beautify.notify('success', data.message);

                            // Reload the modal content from its source URL
                            var sourceUrl = $('#myModal').data('source');
                            if (sourceUrl) {
                                $.ajax({
                                    url: sourceUrl,
                                    type: 'GET',
                                    success: function(html) {
                                        $('#myModal').html(html);
                                        $('#myModal').find('.select2').select2({
                                            theme: 'bootstrap4',
                                            width: '100%'
                                        });
                                    }
                                });
                            }

                            if (data.trigger) {
                                $(document).trigger(data.trigger);
                            }
                        } else {
                            beautify.notify('error', data.message || 'Failed to unassign student.');
                        }
                    },
                    error: function() {
                        beautify.notify('error', 'Something went wrong. Please try again.');
                    }
                });
            }
        );
    });

});
